export const themeStyleDark = {
  backgroundColor: "#F4F5FA",
  primaryColor: "#0065c2",
  primaryCardColor: "white",
  textColor: "black",
  primaryButtonColor: "#0065c2",
  primaryButtonTextColor: "white",
  secondaryButtonColor: "",
};

export const themeStyle = {
  backgroundColor: "#F4F5FA",
  primaryColor: "#0065c2",
  primaryCardColor: "white",
  textColor: "black",
  primaryButtonColor: "#0065c2",
  primaryButtonTextColor: "black",
  secondaryButtonColor: "",
};
